// Content for the "Custom Website" service offering.
// Hardcoded (no Contentful) and shared by the /custom-websites page
// and the homepage teaser.

export const CONTACT_EMAIL = "dynamicwebpartners@gmail.com"

export const included = [
  {
    title: "Custom design",
    body: "Designed around your brand and goals from a blank canvas — never a template.",
  },
  {
    title: "Fully responsive",
    body: "Looks effortless on phone, tablet, and desktop — every screen, every time.",
  },
  {
    title: "Contact / signup form",
    body: "A built-in form that emails submissions straight to your inbox.",
  },
  {
    title: "Social integration",
    body: "Instagram, YouTube, and wherever else your audience already follows you.",
  },
  {
    title: "Speed & polish",
    body: "Fast, modern, and built to make a strong first impression.",
  },
  {
    title: "Up to 3 rounds of revisions",
    body: "We refine it together until every detail feels right.",
  },
]

export const process = [
  {
    title: "Connect",
    body: "Share your vision, inspiration, and assets. We get to know you and your goals.",
  },
  {
    title: "Design & Build",
    body: "We craft your site from scratch — custom-built around your brand.",
  },
  {
    title: "Refine",
    body: "Up to three rounds of revisions to get every detail exactly right.",
  },
  {
    title: "Launch",
    body: "We ship it to the world — fast, polished, and ready to impress.",
  },
]

export const needs = [
  "A few inspiration sites or styles you love",
  "Your assets — photos, images, and video",
  "Your brand — logo and social links",
  "Any copy or words you’d like included",
]

export const featurePrice = {
  title: "Website design & build",
  price: "$1,500",
  body: "A complete custom website, built from scratch — includes up to 3 revision rounds.",
}

export const addOns = [
  {
    title: "Additional revisions",
    price: "$500",
    body: "Per extra 3 rounds, after the first three are used.",
  },
  {
    title: "Self-managed content",
    price: "+$1,000",
    body: "Optional CMS so you can edit your own text, images, and content anytime — no developer needed.",
  },
  {
    title: "Domain name",
    price: "Not included",
    body: "We recommend Squarespace (~$12–20/yr) for simplicity. Optional — any registrar works.",
  },
]

export const faqs = [
  {
    question: "What if I don’t have my content ready?",
    answer:
      "That’s completely fine. Bring what you have and we’ll shape the rest together as we go — you don’t need it all figured out to get started.",
  },
  {
    question: "How many revisions do I get?",
    answer:
      "Up to 3 rounds of revisions are included in the build. Need more? Additional revisions are $500 per extra 3 rounds.",
  },
  {
    question: "Can I update the site myself later?",
    answer:
      "Yes — add self-managed content for $1,000 and you’ll be able to edit your text, images, and content anytime, with no developer needed.",
  },
  {
    question: "Do I need a domain name?",
    answer:
      "A domain isn’t included, but they’re inexpensive (around $12–20/yr). We recommend Squarespace for simplicity, though any registrar works.",
  },
]
